var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 0C10.2862 0 13.232 2.88445 13.3308 6.48006L13.3333 6.66667L13.3283 6.92787C13.2747 8.32105 12.7929 9.63507 11.9596 10.7207L11.828 10.8853L15.8077 14.8649C16.0681 15.1253 16.0681 15.5474 15.8077 15.8077C15.5474 16.0681 15.1253 16.0681 14.8649 15.8077L10.8853 11.828L10.7094 11.9683C9.55826 12.848 8.15163 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667C0 2.98477 2.98477 0 6.66667 0ZM6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61219 3.72115 12 6.66667 12C7.77341 12 8.83092 11.6644 9.70699 11.0509L9.87975 10.9245L10.0592 10.7822L10.454 10.4547L10.7811 10.0605C11.4798 9.21493 11.8965 8.18827 11.9825 7.11705L11.9952 6.90225L12 6.66667C12 3.72115 9.61219 1.33333 6.66667 1.33333Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.ce5bfa6944d3d0c86be4b1108b090b8d.svg";
export { ForwardRef as ReactComponent };